import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  useLastExamEntryCheckboxContainer: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    padding: 4,
    marginBottom: -42,
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      marginBottom: -24
    }
  },
  useLastExamEntryCheckboxLabel: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: "#1a1a1a",
    fontSize: 14
  },
  noPastExams: {
    opacity: 0.5,
    cursor: "default"
  },
  italic: {
    fontStyle: "italic"
  }
}));
